import {
  GET_REQUESTS,
  GET_REQUESTS_SUCCESS,
  GET_REQUESTS_FAILURE,
  ADD_REQUEST,
  ADD_REQUEST_SUCCESS,
  ADD_REQUEST_FAILURE,
  EDIT_REQUEST,
  EDIT_REQUEST_SUCCESS,
  EDIT_REQUEST_FAILURE,
  DELETE_REQUEST,
  DELETE_REQUEST_SUCCESS,
  DELETE_REQUEST_FAILURE,
  GET_SINGLE_REQUEST,
  GET_SINGLE_REQUEST_SUCCESS,
  GET_SINGLE_REQUEST_FAILURE,
} from "./actionTypes";

export const getRequests = () => {
  return {
    type: GET_REQUESTS,
  };
};

export const getRequestsSuccess = (country) => {
  return {
    type: GET_REQUESTS_SUCCESS,
    payload: country,
  };
};

export const getRequestsFailure = (error) => {
  return {
    type: GET_REQUESTS_FAILURE,
    payload: error,
  };
};

export const getSingleRequest = (id) => {
  return {
    type: GET_SINGLE_REQUEST,
    payload: id,
  };
};

export const getSingleRequestSuccess = (country) => {
  return {
    type: GET_SINGLE_REQUEST_SUCCESS,
    payload: country,
  };
};

export const getSingleRequestFailure = (error) => {
  return {
    type: GET_SINGLE_REQUEST_FAILURE,
    payload: error,
  };
};

export const addRequest = (payload) => {
  return {
    type: ADD_REQUEST,
    payload,
  };
};

export const addRequestSuccess = (payload) => {
  return {
    type: ADD_REQUEST_SUCCESS,
    payload,
  };
};

export const addRequestFailure = (error) => {
  return {
    type: ADD_REQUEST_FAILURE,
    payload: error,
  };
};

export const editRequest = (payload) => {
  return {
    type: EDIT_REQUEST,
    payload,
  };
};

export const editRequestSuccess = (payload) => {
  return {
    type: EDIT_REQUEST_SUCCESS,
    payload,
  };
};

export const editRequestFailure = (error) => {
  return {
    type: EDIT_REQUEST_FAILURE,
    payload: error,
  };
};

export const deleteRequest = (id) => {
  return {
    type: DELETE_REQUEST,
    payload: id,
  };
};

export const deleteRequestSuccess = (id) => {
  return {
    type: DELETE_REQUEST_SUCCESS,
    payload: id,
  };
};

export const deleteRequestFailure = (error) => {
  return {
    type: DELETE_REQUEST_FAILURE,
    payload: error,
  };
};
